import { FirmWares, } from 'redux/types/firmwareActionModel';
import * as actionTypes from '../actionTypes';
import { CustomerList, SpatialViewActions, SpatialViewStateInterface } from 'redux/types/spatialViewActionModel';

const initialState: SpatialViewStateInterface = {
    customerData: [],
    isLoading: false,
    error: null,
    addSpatialViewOpen: false,
    isCreatingSpatialView: false,
    isUploadingToS3: false,
    uploadSuccessfull: false,
    EditSpatialViewOpen: false,
    isFetchingGlbUrl: false,
    glbUrl: null as string | null,
    isDeletingSpatialView: false,
    sensorDevices: [],
    tatamaDevices: [],
    isInstallingDevice: false,
    installDeviceSuccess: false,
    isUninstallingDevice: false,
    uninstallDeviceSuccess: false,
    totalDevice: null,
    isTotalDeviceLoading: false,
    isProcessingGlb: false,
    isFetchingLivePolling: false,
    livePollingData: null,
    spatialViewOperations: null,
    isFetchingSpatialViewOperations: false,
};

/* eslint-disable sonarjs/max-switch-cases */
export const spatialViewReducer = (state = initialState, action: SpatialViewActions): SpatialViewStateInterface => {
    switch (action.type) {

        case actionTypes.GET_SPATIAL_VIEW:
            return {
                ...state,
                isLoading: true,
            };
        case actionTypes.GET_SPATIAL_VIEW_SUCCESS:
            return {
                ...state,
                isLoading: false,
                customerData: action?.payload
            };

        case actionTypes.GET_SPATIAL_VIEW_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error,
            };
        case actionTypes.SET_ADD_SPATIAL_VIEW_OPEN:
            return {
                ...state,
                addSpatialViewOpen: action.payload,
            };
        case actionTypes.CREATE_SPATIAL_VIEW:
        case actionTypes.UPDATE_SPATIAL_VIEW:
        case actionTypes.UPDATE_MODEL:
            return { ...state, isCreatingSpatialView: true };
        case actionTypes.CREATE_SPATIAL_VIEW_SUCCESS:
        case actionTypes.UPDATE_SPATIAL_VIEW_SUCCESS:
        case actionTypes.UPDATE_MODEL_SUCCESS:
            return { ...state, isCreatingSpatialView: false };
        case actionTypes.CREATE_SPATIAL_VIEW_FAILURE:
        case actionTypes.UPDATE_SPATIAL_VIEW_FAILURE:
        case actionTypes.UPDATE_MODEL_FAILURE:
            return { ...state, isCreatingSpatialView: false, error: action.payload.error };

        case actionTypes.UPLOAD_FILE_TO_S3:
            return { ...state, isUploadingToS3: true };
        case actionTypes.UPLOAD_FILE_TO_S3_SUCCESS:
            return { ...state, isUploadingToS3: false, uploadSuccessfull: true };
        case actionTypes.UPLOAD_FILE_TO_S3_FAILURE:
            return { ...state, isUploadingToS3: false, error: action.payload.error, uploadSuccessfull: false };
        case actionTypes.FILE_UPLOAD_SUCCESS:
            return {
                ...state,
                uploadSuccessfull: action?.payload,
            };
        case actionTypes.SET_EDIT_SPATIAL_VIEW_OPEN:
            return {
                ...state,
                EditSpatialViewOpen: action.payload,
            };
        case actionTypes.FETCH_GLB_URL:
            return { ...state, isFetchingGlbUrl: true, glbUrl: null };
        case actionTypes.FETCH_GLB_URL_SUCCESS:
            return { ...state, isFetchingGlbUrl: false, glbUrl: action.payload };
        case actionTypes.FETCH_GLB_URL_FAILURE:
            return { ...state, isFetchingGlbUrl: false, error: action.payload.error };
        case actionTypes.DELETE_SPATIAL_VIEW:
            return {
                ...state,
                isDeletingSpatialView: true,
            };

        case actionTypes.DELETE_SPATIAL_VIEW_SUCCESS:
            return {
                ...state,
                isDeletingSpatialView: false,
            };

        case actionTypes.DELETE_SPATIAL_VIEW_FAILURE:
            return {
                ...state,
                isDeletingSpatialView: false,
                error: action.payload.error,
            };

        case actionTypes.FETCH_SENSOR_DEVICES:
            return { ...state, sensorDevices: [] };
        case actionTypes.FETCH_SENSOR_DEVICES_SUCCESS:
            return { ...state, sensorDevices: action.payload };
        case actionTypes.FETCH_SENSOR_DEVICES_FAILURE:
            return { ...state, error: action.payload.error };
        case actionTypes.FETCH_TATAM_DEVICES:
            return { ...state, tatamaDevices: [] };
        case actionTypes.FETCH_TATAM_DEVICES_SUCCESS:
            return { ...state, tatamaDevices: action.payload };
        case actionTypes.FETCH_TATAM_DEVICES_FAILURE:
            return { ...state, error: action.payload.error };
        case actionTypes.INSTALL_SPATIAL_VIEW_DEVICE:
            return { ...state, isInstallingDevice: true, installDeviceSuccess: false };
        case actionTypes.INSTALL_SPATIAL_VIEW_DEVICE_SUCCESS:
            return { ...state, isInstallingDevice: false, installDeviceSuccess: true };
        case actionTypes.INSTALL_SPATIAL_VIEW_DEVICE_FAILURE:
            return { ...state, isInstallingDevice: false, installDeviceSuccess: false, error: action.payload.error };

        case actionTypes.UNINSTALL_SPATIAL_VIEW_DEVICE:
            return { ...state, isUninstallingDevice: true, uninstallDeviceSuccess: false };
        case actionTypes.UNINSTALL_SPATIAL_VIEW_DEVICE_SUCCESS:
            return { ...state, isUninstallingDevice: false, uninstallDeviceSuccess: true };
        case actionTypes.UNINSTALL_SPATIAL_VIEW_DEVICE_FAILURE:
            return { ...state, isUninstallingDevice: false, uninstallDeviceSuccess: false, error: action.payload.error };

        case actionTypes.FETCH_TOTAL_DEVICES:
            return { ...state, isTotalDeviceLoading: true };
        case actionTypes.FETCH_TOTAL_DEVICES_SUCCESS:
            return { ...state, totalDevice: action.payload, isTotalDeviceLoading: false };
        case actionTypes.FETCH_TOTAL_DEVICES_FAILURE:
            return { ...state, error: action.payload.error };
        case actionTypes.START_GLB_PROCESSING:
            return {
                ...state,
                isProcessingGlb: action.payload,
            };
        case actionTypes.FETCH_LIVE_POLLING:
            return { ...state, isFetchingLivePolling: true, livePollingData: null };
        case actionTypes.FETCH_LIVE_POLLING_SUCCESS:
            return { ...state, isFetchingLivePolling: false, livePollingData: action.payload };
        case actionTypes.FETCH_LIVE_POLLING_FAILURE:
            return { ...state, isFetchingLivePolling: false };
        case actionTypes.STOP_LIVE_POLLING:
            return { ...state, isFetchingLivePolling: false, livePollingData: null };
        case actionTypes.FETCH_SPATIAL_VIEW_OPERATIONS:
            return { ...state, isFetchingSpatialViewOperations: true, spatialViewOperations: null };
        case actionTypes.FETCH_SPATIAL_VIEW_OPERATIONS_SUCCESS:
            return { ...state, isFetchingSpatialViewOperations: false, spatialViewOperations: action.payload };
        case actionTypes.FETCH_SPATIAL_VIEW_OPERATIONS_FAILURE:
            return { ...state, isFetchingSpatialViewOperations: false, error: action.payload.error };
        default:
            return {
                ...state,
            };
    }
};
